import { diffForHumans, formatDateTime } from "@/utils/helper";
import AssignedToDropdown from "@/components/AssignedToDropdown/AssignedToDropdown";
import {
  CONTACT_SUPPORT_STATUS,
  CONTACT_SUPPORT_TYPE,
} from "@/constant/ContactSupport/status";
import { contactSupportsApi } from "@/apis/apis";
import config from "@/config";

export const columns = (userOptions, showIsFetching) => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => (
        <div>{`${row.original.status?.type ?? "-"} - ${
          row.original.status?.name ?? "-"
        }`}</div>
      ),
    },
    {
      accessorKey: "p_index",
      header: "P-Index",
      cell: ({ row }) => <div>{row.original.reason?.type ?? "-"}</div>,
    },
    {
      accessorKey: "reason",
      header: "Reason",
      cell: ({ row }) => <div>{row.original.reason?.name ?? "-"}</div>,
      enableSorting: false,
    },
    {
      accessorKey: "created_at",
      header: "Start Date",
      cell: ({ row }) => formatDateTime(row.original.created_at, true),
    },
    {
      accessorKey: "started",
      header: "Started",
      cell: ({ row }) => (
        <span className="capitalize">
          {diffForHumans(row.original.created_at)}
        </span>
      ),
    },
    {
      accessorKey: "last_message",
      header: "Latest Message",
      cell: ({ row }) => diffForHumans(row.original.last_message) ?? "-",
    },
    {
      accessorKey: "latest_message_by",
      header: "Latest Message By",
    },
    {
      accessorKey: "assigned_to",
      header: "Assigned To",
      size: 150,
      cell: ({ row }) => {
        const { status, assigned_to } = row.original;

        const isAssigned =
          status?.type !== CONTACT_SUPPORT_TYPE.CLOSED &&
          status?.name !== CONTACT_SUPPORT_STATUS.WAITING;

        return isAssigned ? (
          <AssignedToDropdown
            api={contactSupportsApi}
            data={row.original}
            userOptions={userOptions}
            showIsFetching={showIsFetching}
          />
        ) : (
          <div>{assigned_to?.first_name ?? "Unassigned"}</div>
        );
      },
    },
    {
      accessorKey: "assigned_by",
      header: "Assigned By",
      cell: ({ row }) => row.original.assigned_by?.first_name ?? "-",
    },
    {
      accessorKey: "creatorable_username",
      header: "Creator Username",
      cell: ({ row }) => row.original.creatorable?.username ?? "-",
    },
    {
      accessorKey: "creatorable_first_name",
      header: "Creator First Name",
      cell: ({ row }) => row.original.creatorable?.first_name ?? "-",
    },
    {
      accessorKey: "code",
      header: "Ticket Transaction-ID",
    },
    {
      accessorKey: "transaction_id",
      header: "Reference Transaction-ID ",
      cell: ({ row }) =>
        (row.original.transaction_reference && (
          <a
            href={row.original.transaction_reference.code ?? "#"}
            className="underline text-blue-800"
            target="_blank"
            rel="noreferrer"
          >
            {row.original.transaction_reference.code}
          </a>
        )) ||
        "-",
    },
    {
      accessorKey: "user_reference.username",
      header: "Reference Username",
      cell: ({ row }) =>
        (row.original.user_reference && (
          <a
            href={`${config.app.baseUrl}/user-management/web-user-list?filter[keyword]=${row.original.user_reference?.username}`}
            className="underline text-blue-800"
            target="_blank"
            rel="noreferrer"
          >
            {row.original.user_reference?.username}
          </a>
        )) ||
        "-",
    },
    {
      accessorKey: "url_reference",
      header: "Reference URL",
      cell: ({ row }) =>
        (row.original.url_reference && (
          <a
            href={row.original.url_reference ?? "#"}
            className="underline text-blue-800"
            target="_blank"
            rel="noreferrer"
          >
            {row.original.url_reference}
          </a>
        )) ||
        "-",
    },
    {
      accessorKey: "admin_comment",
      header: "Admin Comment",
    },
  ];
};
